import React from 'react';
import ReactDOM from 'react-dom/client';

import { forceInternalAccountInUrl } from '@climatepartner/app-shell';
import { InitMuiLicense } from '@climatepartner/components';

import { App } from './App';

InitMuiLicense(import.meta.env.VITE_MUI_LICENCE_KEY);
forceInternalAccountInUrl();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
